import { OptionsControl } from './options.model';
import {
  BaseControl,
  TransformText
} from '@app/shared/dynamic-form/shared/controls/base-control';

interface OptionsTextbox extends OptionsControl<any> {
  type: string;
  customMin?: number;
  customMax?: number;
  customDecimalMax?: number;
  transform?: TransformText;
  default: any;
  thousandsSeparator?: string;
  decimalSeparator?: string;
}

export class Textbox extends BaseControl<any> implements OptionsTextbox {
  controlType = 'textbox';
  type: string;
  customMin: number;
  customMax: number;
  customDecimalMax: number;
  transform?: TransformText;
  default: any;
  thousandsSeparator?: string;
  decimalSeparator?: string;

  constructor(options: Partial<OptionsTextbox>) {
    super(options);
    this.type = options.type || 'text';
    this.customMin = options.customMin;
    this.customMax = options.customMax;
    this.customDecimalMax = options.customDecimalMax;
    this.transform = options.transform;
    this.default = options.default;
    this.thousandsSeparator = options.thousandsSeparator;
    this.decimalSeparator = options.decimalSeparator;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/textbox.ts